import { useState } from 'react';

import { fontStyles } from '@/styles/typography';

import { FeedbackAnimation } from './FeedbackAnimation';
import { ToastContainer, ToastTitle, ToastContent, useAutoDismiss } from './ToastComponents';

export interface PostFeedbackToastProps {
  hasContactInfo: boolean;
  onClose?: () => void;
}

/**
 * Toast shown after user successfully submits feedback
 */
export function PostFeedbackToast({ hasContactInfo, onClose }: PostFeedbackToastProps) {
  const [isHovered, setIsHovered] = useState(false);

  useAutoDismiss(isHovered, onClose, false);

  return (
    <ToastContainer onClose={onClose} showProgressAnimation={false} onHoverChange={setIsHovered}>
      <FeedbackAnimation feedback="success" className="flex-shrink-0 relative z-10" />

      {/* Content */}
      <div className="flex flex-col gap-1 min-w-0 flex-1 relative z-10">
        <ToastTitle
          className={fontStyles({
            variant: 'LABEL_MD',
            class: ['text-token-gray-1600'],
          })}
        >
          Thanks for your feedback
        </ToastTitle>

        <ToastContent>
          <span
            className={fontStyles({
              variant: 'BODY_SM',
              class: ['text-token-gray-800'],
            })}
          >
            {hasContactInfo
              ? "We'll reach out using the contact details you provided if we have any follow-up questions."
              : 'Our team will do our best to improve your experience with Matcha.'}
          </span>
        </ToastContent>
      </div>
    </ToastContainer>
  );
}
